import { Dispatch, SetStateAction } from 'react';

import { Alert } from '@mui/material';

import { ContentModal } from 'components/modal';
import { SubTitle } from 'components/text';

interface CarrinhoFalhasModal {
    open: boolean;
    setOpen: Dispatch<SetStateAction<boolean>>;
    falha: string;
}

/**
 * Recebe um array de PedigoLog e retorna um array de strings
 */

export function CarrinhoFalhasModal({ falha, open, setOpen }: CarrinhoFalhasModal) {
    return (
        <ContentModal
            closeButton
            open={Boolean(open)}
            setOpen={setOpen}
            sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 2,
                borderRadius: 1,
                width: { xs: '90dvw', sm: 'auto' },
            }}
        >
            <SubTitle label="Falha" sx={{ mb: 0 }} />

            <Alert variant="outlined" severity="error">
                {falha}
            </Alert>
        </ContentModal>
    );
}
